import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import * as registerServiceWorker from './registerServiceWorker';
import 'styles/icomoon/style.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker.register();
